<template>

    <v-card class="ma-4">
        <v-card-title class="HeaderTitle">
            <v-toolbar color="primary" density="compact" flat>
                <v-toolbar-title class="textcolor">
                    Verbrauchsstelle (Optional)
                </v-toolbar-title>
            </v-toolbar>
        </v-card-title>

        <v-card-text>
            <v-form ref="form">
                <v-col>
                    <v-row class="mt-1 ml-1 mr-1">
                        <v-text-field v-if="Vorhanden('VerbrauchsstelleStrasse') == true"
                            v-model="$store.state.VerbrauchsstelleStrasse"
                            :label="$store.state.VerbrauchstelleStrasseDisplayName" color="primary" variant="outlined"
                            density="compact"
                            :rules="[rules.required('VerbrauchsstelleStrasse', $store.state.VerbrauchsstelleStrasse)]">
                        </v-text-field>

                        <v-text-field class="ml-2" v-if="Vorhanden('VerbrauchsstelleHausnummer') == true"
                            v-model="$store.state.VerbrauchsstelleHausnummer"
                            :label="$store.state.VerbrauchstelleHausnummerDisplayName" color="primary"
                            variant="outlined" density="compact"
                            :rules="[rules.required('VerbrauchsstelleHausnummer', $store.state.VerbrauchsstelleHausnummer)]">
                        </v-text-field>
                    </v-row>
                </v-col>

                <v-col>
                    <v-row class="mr-1 ml-2">
                        <v-text-field v-if="Vorhanden('VerbrauchsstellePlz') == true"
                            v-model="$store.state.VerbrauchsstellePlz"
                            :label="$store.state.VerbrauchstellePlzDisplayName" color="primary" variant="outlined"
                            density="compact"
                            :rules="[rules.required('VerbrauchsstellePlz', $store.state.VerbrauchsstellePlz)]">
                        </v-text-field>

                        <v-text-field class="ml-2" v-if="Vorhanden('VerbrauchsstelleOrt') == true"
                            v-model="$store.state.VerbrauchsstelleOrt"
                            :label="$store.state.VerbrauchstelleOrtDisplayName" color="primary" variant="outlined"
                            density="compact"
                            :rules="[rules.required('VerbrauchsstelleHausnummer', $store.state.VerbrauchsstelleOrt)]">
                        </v-text-field>
                    </v-row>
                </v-col>

                <v-col>
                    <v-row class="ml-1 mr-1">
                        <v-text-field v-if="Vorhanden('VerbrauchsstelleEtage') == true"
                            v-model="$store.state.VerbrauchsstelleEtage"
                            :label="$store.state.VerbrauchstelleEtageDisplayName" color="primary" variant="outlined"
                            density="compact"
                            :rules="[rules.required('VerbrauchsstelleEtage', $store.state.VerbrauchsstelleEtage)]">
                        </v-text-field>
                    </v-row>
                </v-col>


            </v-form>
        </v-card-text>
    </v-card>


    <v-dialog v-model="Fehler">
        <Errors />
    </v-dialog>

</template>

<script setup>
import { ref, onMounted } from "vue";
import { useStore } from "vuex";

const store = useStore()
const loading = ref(false);

var rules = ref({
    required(Feld, value) {
        var istPflichtfeld = false;
        store.state.VertragsPflichtfelder.forEach((element) => {
            if (element == Feld) istPflichtfeld = true;
        });
        if (istPflichtfeld == true) return !!value || "Pflichtfeld";
        else return true;
    },
});

function Vorhanden(Feld) {
    var FeldNichtvorhandewn = false;
    store.state.FelderNichtAnzeigen.forEach((element) => {
        if (element == Feld) FeldNichtvorhandewn = true;
    });
    if (FeldNichtvorhandewn == true) return false;
    else return true;
}



</script>